import { QQLoginMessage } from './qq-login';
/**
 * 主要处理QQ传过来的事件
 */
var QQMessage = /** @class */ (function () {
    function QQMessage() {
        this.qqLoginMessage = new QQLoginMessage();
    }
    return QQMessage;
}());
export { QQMessage };
